import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import React from 'react';

import pagesUrls from 'constants/pagesUrls';

import Icon, { IconTypes } from 'components/basic/Icon';
import MenuItem from 'components/pagesComponents/landing/Main/components/DesktopMenu/MenuItem';
import { menuItems } from 'components/pagesComponents/landing/Main/constants';

import { useAppSelector } from 'redux-store';

import TopBanner from '../../../../../complex/TopBanner';
import LogoImg from './desktop-logo.svg';

import s from './DesktopMenu.module.scss';

export default function DesktopMenu({
  hideTopBanner,
}: {
  hideTopBanner?: boolean;
}): JSX.Element {
  const profileState = useAppSelector(state => state.profile);
  const { appleOneLinkUrl, googleOneLinkUrl } = useAppSelector(
    state => state.experiments,
  );
  const isTopBannerShowed = useAppSelector(state => state.ui.isTopBannerShowed);
  const items = menuItems.map(item => (
    <MenuItem key={item.header} item={item} />
  ));

  return (
    <>
      <div
        className={cn(s.fixer, {
          [s.wide]: isTopBannerShowed,
        })}
      />
      <div className={s.wrapper}>
        <TopBanner hide={hideTopBanner} />
        <div className={s.content}>
          <LogoImg className={s.logo} width="120" />
          <div className={s.itemsWrapper}>
            {items}
            <a href="https://welltory.com/plans/" className={s.link}>
              Plans
            </a>
            <a href="https://welltory.com/integrations/" className={s.link}>
              Integrations
            </a>
            <a href="https://welltory.com/science/" className={s.link}>
              Science
            </a>

            {!profileState.isAuthenticated && (
              <span
                onClick={(): void => {
                  logEvent('Web_Site_Header_Sign-in_Button_Clicked');
                }}
              >
                <a
                  href={`https://app.welltory.com${pagesUrls.auth}`}
                  className={s.link}
                >
                  Sign in
                </a>
              </span>
            )}
            <a
              href={appleOneLinkUrl}
              className={s.storeLink}
              onClick={(): void => {
                logEvent('Web_Site_Header_Store_Button_Clicked', {
                  type: 'appstore',
                });
              }}
            >
              <Icon icon={IconTypes.apple} size={32} />
            </a>
            <a
              href={googleOneLinkUrl}
              className={s.storeLink}
              onClick={(): void => {
                logEvent('Web_Site_Header_Store_Button_Clicked', {
                  type: 'googleplay',
                });
              }}
            >
              <Icon icon={IconTypes.googlePlay} size={32} />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
